import { WindowLocation } from '@gatsbyjs/reach-router';
import { Flow, FlowStep } from './flow';
import FlowManager from './flow-manager';
import Issue from '../issue/technical-issue';
import Timeout from '../issue/timeout';
import FormsFlow from '../forms/flow/forms-flow';
import { ContextService } from '../../hoc/context/product/context';
import { EnrollmentContextService, UserInputType } from '../../hoc/context/enrollment/enrollment-context';
import ConfirmationFlow from '../confirmation/flow/confirmation-flow';
import WizardFlow from '../wizard/flow/wizard-flow';
import { requestStatus } from '../../hoc/context/api';

export const routes = {
	wizard: 'wizard',
	forms: 'forms',
	confirmation: 'confirmation',
	issue: 'issue',
	timeout: 'timeout',
}

export class EnrollmentFlow extends Flow {

	get steps(): FlowStep[] {
		return [
			{
				path: routes.wizard,
				component: FlowManager,
				flow: new WizardFlow(routes.wizard, this.ctxt, this.enrollmentCtxt, this),
			},
			{
				path: routes.forms,
				component: FlowManager,
				flow: new FormsFlow(routes.forms, this.ctxt, this.enrollmentCtxt, this),
				condition: (configuration: ContextService, 
							enrollmentCtxt: EnrollmentContextService) => {
								if (enrollmentCtxt.isFastTrack(configuration)) {
									enrollmentCtxt.resetInput(UserInputType.FORMS);
								}
								return !enrollmentCtxt.isFastTrack(configuration)
							}
			},
			{
				path: routes.confirmation,
				component: FlowManager,
				flow: new ConfirmationFlow(routes.confirmation, this.ctxt, this.enrollmentCtxt, this),
			},
			{
				path: routes.issue,
				component: Issue,
				condition: () => false,
				flow: this
			},
			{
				path: routes.timeout,
				component: Timeout,
				condition: () => false,
				flow: this
			}
		];
	}

	next(location: WindowLocation) {
		if (location?.pathname === this.uri) {
			this.navigate(`${this.steps[0].path}${location?.search}`, {replace: true});
		} else {
			let index = this.steps.findIndex((step) =>
				location.pathname.includes(this.uri + step.path)
			);
			if (index > -1) {
				let routeCondition;
				let isStepNeeded;
				while(!isStepNeeded) {
					index++;
					routeCondition = this.steps[index]?.condition;
					isStepNeeded = !routeCondition || routeCondition(this.ctxt, this.enrollmentCtxt);
				}
				if (this.steps.length > index) {
					this.navigate(this.steps[index].path);
				} else if (this.onEnd) {
					this.onEnd(location);
				}
			} else {
				this.onEnd(location);
			}
		}
	}

	terminate(location: WindowLocation, status: requestStatus) {
		switch (status) {
			case requestStatus.ERROR:
				this.navigate(routes.issue);
				break;
			case requestStatus.TIMEOUT:
				this.navigate(routes.timeout);
				break;
			default:
				super.terminate(location, status);
		}
	}
	
}

export default EnrollmentFlow;
